import styles from '../products-add-new-product.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRootStore } from '../../../../mobx-stores/store-provider'
import { SectionContainer, H2, LabeledLine, Input, TagsEditor, Textarea, Button, Text2 } from '@touche-lts/panel-ui/dist'
import { IconEdit } from 'assets/icons'
import { useEffect, useState } from 'react'
import { Department, DepartmentCategory, DepartmentSubcategory, DepartmentTypes } from 'models/departments'

const ProductsDetailsSectionComponent = (props) => { // TODO-A To put a model here
    const {
        className,
        style,
        editMode,
        productId
    } = props,
    {
        productsDetailsStore: {
            productDetailsStore,
            setProductDetailsStoreProps,
            updateProductDetails,
            getAllDepartments,
            allDepartments,
            allCategories,
            allSubcategories,
            allTypes,
            selectedDepartment,
            selectedCategory,
            selectedSubcategory,
            selectedType,
            getAllCategories,
            getSubcategories,
            getTypes,
            resetDepartments,
            resetCategories 
        }
    } = useRootStore(),

    [editModeSection, setEditModeSection] = useState<boolean>(false),

    onCancelEditClick = () => {
        setEditModeSection(false)
    },

    onSaveClick = async () => {
        updateProductDetails(productId)
        setEditModeSection(false)
    },

    handleDepartmentChange = (ev): void => {
        setProductDetailsStoreProps({department: {id: Number(ev.target.value)}})
        resetDepartments();
        getAllDepartments();
        if(!selectedDepartment.length) {
            getAllCategories();
        }
    },

    handleCategoryChange = (ev): void => {
        setProductDetailsStoreProps({category: {id: Number(ev.target.value)}})
        resetCategories();
        // if(!selectedCategory.length) {
            getSubcategories();
            getTypes();
        // }
    },

    handleSubcategoryChange = (ev): void => {
        setProductDetailsStoreProps({subcategory: {id: Number(ev.target.value)}})
        // if(!selectedCategory.length) {
            getTypes();
        // }
    }

    useEffect(()=> {
        if(!editMode) setEditModeSection(true)
        // getAllDepartments()
    }, [editMode, getAllDepartments])

  return (
    <SectionContainer className={cl(className)} style={style} colorPreset='dark' extraPaddingBottom>
        <div className="d-flex justify-content-between">
            <H2 className={styles.sectionHeadingWithButton} colorPreset='dark'>
            Product Details
            </H2>
            { editMode && !editModeSection && (
                <Button preset='icon' onClick={() => setEditModeSection(true)}>
                    <IconEdit fill={styles.white} />
                </Button>
            )}
            { editMode && editModeSection && (
                <div className={styles.headingButtonsEditContainer}>
                    <Button
                        preset='secondary'
                        colorPreset='dark'
                        onClick={onCancelEditClick}
                    >
                        Cancel
                    </Button>
                    <Button preset='primary' onClick={onSaveClick}>
                        Save
                    </Button>
                </div>
            )}
        </div>

        { editModeSection && (
        <div className="row pt-4">
            <div className="col-lg-6">
                <LabeledLine
                    label='Product name*'
                    colorPreset='dark'
                >
                    <Input
                    colorPreset='dark'
                    placeholder='Product name*'
                    value={productDetailsStore?.name}
                    onChange={name => setProductDetailsStoreProps({name})}
                    />
                </LabeledLine>
                <LabeledLine
                    label='Department*'
                    colorPreset='dark'
                    className='mt-3'
                >
                    <select onChange={handleDepartmentChange} className={styles.selectDepartments}>
                        {!productDetailsStore?.department?.id && <option value="">Select department</option>}
                        {allDepartments.map((department: Department, index) => {
                        return (
                            
                               <option key={department?.id || index} value={department?.id} selected={department?.id === productDetailsStore?.department?.id}>{department?.name}
                                      </option>
                                  )
                              })}
                    </select>
                </LabeledLine>
                <LabeledLine
                    label='Category*'
                    colorPreset='dark'
                    className='mt-3'
                >
                    <select onChange={handleCategoryChange} className={styles.selectDepartments}>
                        {!productDetailsStore?.category?.id && <option value="">Select category</option>}
                        {allCategories.map((category: DepartmentCategory) => {
                        return (
                            <>
                                <option value={category?.id} selected={category?.id === productDetailsStore?.category?.id}>{category?.name}</option>
                            </>
                        )
                        })}
                    </select>
                </LabeledLine>
                <LabeledLine
                    label='Subcategory'
                    colorPreset='dark'
                    className='mt-3'
                >
                    <select onChange={handleSubcategoryChange} className={styles.selectDepartments}>
                        {!productDetailsStore?.subcategory?.id && <option value="">Select subcategory</option>}
                        {allSubcategories.map((subcategory: DepartmentSubcategory) => {
                        return (
                            <>
                                <option value={subcategory?.id} selected={subcategory?.id === productDetailsStore?.subcategory?.id}>{subcategory?.name}</option>
                            </>
                        )
                        })}
                    </select>
                </LabeledLine>
                <LabeledLine
                    label='Type'
                    colorPreset='dark'
                    className='mt-3'
                >
                    <select 
                        onChange={ev => setProductDetailsStoreProps({type: {id: Number(ev.target.value)}})}
                        className={styles.selectDepartments}
                    >
                        {!productDetailsStore?.type?.id && <option value="">Select type</option>}
                        {allTypes.map((type: DepartmentTypes) => {
                        return (
                            <>
                                <option value={type?.id} selected={type?.id === productDetailsStore?.type?.id}>{type?.name}</option>
                            </>
                        )
                        })}
                    </select>
                </LabeledLine>                
                <LabeledLine
                    label='Manufacturer*'
                    colorPreset='dark'
                    className='mt-3'
                >
                    <Input
                    colorPreset='dark'
                    placeholder='Manufacturer'
                    value={productDetailsStore?.manufacturer}
                    onChange={manufacturer => setProductDetailsStoreProps({manufacturer})}
                    />
                </LabeledLine>
                <LabeledLine
                    label='Tags'
                    preset='tags'
                    colorPreset='dark'
                    className='mt-3'
                >
                    <TagsEditor
                    colorPreset='dark'
                    tags={productDetailsStore?.tags}
                    onChange={tags => setProductDetailsStoreProps({tags})}
                    editMode
                    />
                </LabeledLine>
            </div>
            <div className="col-lg-6">
                <LabeledLine
                    label='Description'
                    style={{ width: '100%', alignItems: 'stretch' }}
                    colorPreset='dark'
                >
                    <Textarea
                    className={styles.textarea}
                    colorPreset='dark'
                    value={productDetailsStore?.info}
                    onChange={info => setProductDetailsStoreProps({info})}
                    />
                </LabeledLine>
            </div>
        </div>
        )}

        { !editModeSection && (
        <div className="row pt-4">
            <div className="col-lg-6">
                <LabeledLine
                    label='Product name'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {productDetailsStore?.name ? productDetailsStore?.name : '-'}
                </Text2>
                </LabeledLine>
                <LabeledLine
                    label='Departments'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {!!selectedDepartment.length ? selectedDepartment[0]?.name : '-'}
                </Text2>
                </LabeledLine>
                <LabeledLine
                    label='Category'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {!!selectedCategory.length ? selectedCategory[0]?.name : '-'}
                </Text2>
                </LabeledLine>
                <LabeledLine
                    label='Subcategory'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {!!selectedSubcategory.length ? selectedSubcategory[0]?.name : '-'}
                </Text2>
                </LabeledLine>
                <LabeledLine
                    label='Type'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {!!selectedType.length ? selectedType[0]?.name : '-'}
                </Text2>
                </LabeledLine>
                <LabeledLine
                    label='Manufacturer'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {productDetailsStore?.manufacturer ? productDetailsStore?.manufacturer : '-'}
                </Text2>
                </LabeledLine>
                <LabeledLine
                    label='Tags'
                    preset='tags'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {productDetailsStore?.tags ? productDetailsStore?.tags : '-'}
                </Text2>
                </LabeledLine>
            </div>
            <div className="col-lg-6">
                <LabeledLine
                    label='Description'
                    style={{ width: '100%', alignItems: 'stretch' }}
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {productDetailsStore?.info ? productDetailsStore?.info : '-'}
                </Text2>
                </LabeledLine>
            </div>
        </div>
        )}

    </SectionContainer>
  )
},

ProductsDetailsSectionProduct = observer(ProductsDetailsSectionComponent)
export { ProductsDetailsSectionProduct }
